// tslint:disable:jsx-no-string-ref

import React, { Component } from 'react';
import Footer from '../components/Footer';
import HeaderLogo from '../components/HeaderLogo';

export default class Maintenance extends Component {
    componentDidMount() {
        window.scrollTo(0, 0);
    }

    render() {
        return (
            <div className="maintenance">
                <header className="header header--unlogged scrolled">
                    <HeaderLogo />
                </header>

                <section ref="home" className="section--hero">
                    <div className="wrapper">
                        <div className="section--hero__holder">
                            <div className="section--hero__holder__item">
                                <h1>
                                    <span>WetNotes.</span>
                                    <br />
                                    <span>Maintenance is under way</span>
                                </h1>

                                <p>
                                    WetNotes are currently undergoing scheduled
                                    maintenance. By this, we hope to deliver a
                                    better and more stable system for all
                                    Divesoft customers. Our plan is to make
                                    everything happen in the next couple of
                                    hours. We are sorry for the inconvenience.<br />
                                    While the maintenance is running, you cannot
                                    log in to WetNotes. This will return to
                                    normal as soon as we are done. Thank you for
                                    your understanding!
                                </p>
                            </div>

                            <div className="section--hero__holder__item" />
                        </div>
                    </div>
                </section>

                <Footer ref="footer" logged={false} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Maintenance.tsx